import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
}
const sizes = {
  sm: 'max-w-md',
  md: 'max-w-lg',
  lg: 'max-w-2xl'
};
export function Modal({
  open,
  onClose,
  title,
  description,
  children,
  footer,
  size = 'md'
}: ModalProps) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    if (open) document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  return createPortal(<AnimatePresence data-id="element-188">
      {open && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-189">
          <motion.div className="absolute inset-0 bg-black/60 backdrop-blur-sm" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} data-id="element-190" />
          <motion.div role="dialog" aria-modal="true" aria-label={title} className={`relative z-10 w-full ${sizes[size]} max-h-[90vh] overflow-hidden rounded-2xl border border-slate-700 bg-slate-900 shadow-2xl`} initial={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 30
      }} data-id="element-191">
            <div className="flex items-start justify-between border-b border-slate-800 px-5 py-4" data-id="element-192">
              <div data-id="element-193">
                <h2 className="text-base font-semibold text-slate-100" data-id="element-194">
                  {title}
                </h2>
                {description && <p className="mt-0.5 text-sm text-slate-400" data-id="element-195">{description}</p>}
              </div>
              <button onClick={onClose} aria-label="关闭" className="rounded-lg p-1 text-slate-400 hover:bg-slate-800 hover:text-slate-200" data-id="element-196">
                <XIcon className="h-5 w-5" data-id="element-197" />
              </button>
            </div>
            <div className="max-h-[60vh] overflow-y-auto px-5 py-4" data-id="element-198">
              {children}
            </div>
            {footer && <div className="flex justify-end gap-2 border-t border-slate-800 px-5 py-4" data-id="element-199">
                {footer}
              </div>}
          </motion.div>
        </div>}
    </AnimatePresence>, document.body);
}